"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = void 0;
const react_1 = require("react");
const ConfigContext_1 = require("../contexts/ConfigContext");
/**
 * A generic hook that will return the client that has been setup
 * for the particular app through the ConfigContext provider.
 *
 * @example
 * const config = useConfig<IZamAppConfig>()
 * // will return the config for the zambrero
 */
const useConfig = () => {
    const { config } = (0, react_1.useContext)(ConfigContext_1.ConfigContext);
    return config;
};
exports.useConfig = useConfig;
//# sourceMappingURL=useConfig.js.map